<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-2">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoCombustible.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-2">
				<label>Litros</label>
				<vue-numeric
					class="form-control "
					separator=","
					placeholder="0"
					:precision="0"
					v-model="VehiculoCombustible.Litros"
				></vue-numeric>
			</div>
			<div class="col-lg-5 form-group">
				<label>Proveedores</label>	
				<treeselect
					:disabled="DisabledProveedores"
					:maxHeight="100"
					@input="get_proveedores(proveedoresId)"
					:options="ListaProveedores"
					placeholder="Busque un proveedor..."
					v-model="VehiculoCombustible.IdProveedor"
					noResultsText="Resultados no encontrados"
					noOptionsText="Opciones no disponibles"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-3">
				<label for="">Número Factura o Recibo</label>
				<input type="text" class="form-control" v-model="VehiculoCombustible.NumFactura">
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label for="">Fecha Factura o Recibo *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoCombustible.Fecha" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-2">
				<label> Credito (días) </label>
				<!-- <input
					@input="sumDayPay()"
					class="form-control form-finanza"
					:precision="0"
					v-model="VehiculoCombustible.DiasCredito"
					placeholder="0"
				/> -->
				<select v-model="VehiculoCombustible.DiasCredito" class="form-control" @change="sumDayPay">
					<option value="0">Contado</option>
					<option value="15">15 días</option>
					<option value="30">30 días</option>
					<option value="60">60 días</option>
					<option value="90">90 días</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha pago *</label>
                <v-date-picker :masks="{input:'DD-MM-YYYY'}" v-model="VehiculoCombustible.FechaPago" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Factura</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="facturacombustible" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoFactura" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoCombustible.Observaciones" cols="10" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Combustible",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Combustible',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoCombustible:{
                IdVehiculoCombustible:0,
                IdVehiculo:0,
                Fecha:'',
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:'',
				ArchivoFactura:'',
				Litros:0
            },
			ArchivoFactura:'',
            errorvalidacion:[],
			ListaProveedores: [],
			IndexPaqueteCta:0,
			DisabledProveedores:false
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
			let FechaPago='';
            if (this.VehiculoCombustible.Fecha!='' && this.VehiculoCombustible.Fecha!=undefined) {
                let day=this.VehiculoCombustible.Fecha.getDate();
                let month=this.VehiculoCombustible.Fecha.getMonth()+1;
                let year=this.VehiculoCombustible.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.VehiculoCombustible.FechaPago!='' && this.VehiculoCombustible.FechaPago!=undefined) {
                let day=this.VehiculoCombustible.FechaPago.getDate();
                let month=this.VehiculoCombustible.FechaPago.getMonth()+1;
                let year=this.VehiculoCombustible.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoCombustible',this.VehiculoCombustible.IdVehiculoCombustible);
            formData.set('IdVehiculo',this.VehiculoCombustible.IdVehiculo);
            formData.set('Valor',this.VehiculoCombustible.Valor);
			formData.set('NumFactura',this.VehiculoCombustible.NumFactura);
			formData.set('DiasCredito',this.VehiculoCombustible.DiasCredito);
			formData.set('IdProveedor',this.VehiculoCombustible.IdProveedor);
            formData.set('Observaciones',this.VehiculoCombustible.Observaciones);
			formData.set('Litros',this.VehiculoCombustible.Litros);
			formData.set('ArchivoFactura',this.VehiculoCombustible.ArchivoFactura);
            formData.set('Fecha',Fecha);
			formData.set('FechaPago',FechaPago);
			let image=this.$refs.facturacombustible.files[0];
			formData.append('ArchivoFacturaFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculocombustible/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Combustible").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoCombustible={
                IdVehiculoCombustible:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
				Litros:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:new Date(),
				ArchivoFactura:''
            },
			this.ArchivoFactura='Elegir archivo (0.5MB)';
			this.IndexPaqueteCta=0;
			this.DisabledProveedores=false;
        },
		Recuperar(){
            this.$http.get('vehiculocombustible/recovery',{
                params:{
                    IdVehiculoCombustible:this.VehiculoCombustible.IdVehiculoCombustible
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculocombustible;
                this.VehiculoCombustible.IdVehiculoCombustible=objres.IdVehiculoCombustible;
                this.VehiculoCombustible.IdVehiculo=objres.IdVehiculo;
                this.VehiculoCombustible.Valor=objres.Valor;
                this.VehiculoCombustible.Observaciones=objres.Observaciones;
				this.VehiculoCombustible.IdProveedor=objres.IdProveedor == 0 ? null : objres.IdProveedor;
				this.VehiculoCombustible.DiasCredito=objres.DiasCredito;
				this.VehiculoCombustible.NumFactura=objres.NumFactura;
				this.VehiculoCombustible.ArchivoFactura=objres.ArchivoFactura;
				this.VehiculoCombustible.Observaciones=objres.Observaciones;
				this.VehiculoCombustible.Litros=objres.Litros;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoCombustible.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaPago.replace(/-/g, "\/");
                this.VehiculoCombustible.FechaPago=new Date(formatedDate2);
				this.ArchivoFactura=objres.ArchivoFactura;

            })
        },
		SubirArchivo(){
			const image = this.$refs.facturacombustible.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.facturacombustible;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.facturacombustible;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoFactura='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoFactura=image.name;
		},
		get_proveedores(id) {
			this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
				});
		},
		sumDayPay() {
			let days = this.VehiculoCombustible.DiasCredito;
			let dateParam = this.VehiculoCombustible.Fecha;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.VehiculoCombustible.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.VehiculoCombustible.FechaPago=this.VehiculoCombustible.Fecha;
			}
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
			this.get_proveedores();
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoCombustible.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoCombustible.IdVehiculoCombustible = Id;
				this.Recuperar();
			}
			let User=JSON.parse(sessionStorage.getItem("user"));
			this.IndexPaqueteCta=User.listaPaquetesPrincipal.findIndex((element)=>element.Paquete=='Cuentas por Pagar / Administración' || element.Paquete=='Cuentas por Pagar / Operaciones');
			if (this.IndexPaqueteCta==-1) {
				this.DisabledProveedores=true;
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
